"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NoResults", {
    enumerable: true,
    get: function() {
        return NoResults;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../contexts/Theme");
const _Text = require("../Text/Text");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const NoResults = (param)=>{
    let { text, ...props } = param;
    const theme = (0, _Theme.useTheme)();
    const { colors } = theme;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "a29939548b0844af",
                [
                    colors.grayscale[60],
                    colors.grayscale[5]
                ]
            ]
        ]) + " " + "empty-view d-flex flex-column justify-content-center align-items-center"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "a29939548b0844af",
                [
                    colors.grayscale[60],
                    colors.grayscale[5]
                ]
            ]
        ]) + " " + "icon"
    }, /*#__PURE__*/ _react.default.createElement(props.icon, {
        size: 20,
        color: colors.grayscale[40]
    })), /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "extra-small",
        className: "mt-5 text"
    }, text)), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "a29939548b0844af",
        dynamic: [
            colors.grayscale[60],
            colors.grayscale[5]
        ]
    }, ".empty-view.__jsx-style-dynamic-selector{width:100%;height:-webkit-calc(100% - 6rem);height:-moz-calc(100% - 6rem);height:calc(100% - 6rem);font-size:14px;color:".concat(colors.grayscale[60], "}.icon.__jsx-style-dynamic-selector{-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;height:56px;width:56px;line-height:56px;background-color:").concat(colors.grayscale[5], ";text-align:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}")));
};

//# sourceMappingURL=NoResults.js.map